<h1 mat-dialog-title class="title">Extend Trial</h1>
<div mat-dialog-content class="content">

  @if (freeTrialProperties) {
    <div class="extend-trial-form">
      <div class="free-trial-property">
        <mat-form-field id="trial-expiry-date-field">
          <mat-label>Trial Expiry Date</mat-label>
          <input matInput [matDatepicker]="trialExpiryDatePicker" [min]="getMinExpiryDate()" [max]="getMaxExpiryDate()"
            [formControl]="trialEndDate" (dateChange)="updateExtensionDays()" />
          <mat-datepicker-toggle matSuffix [for]="trialExpiryDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #trialExpiryDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="free-trial-property">
        <mat-form-field id="trial-remaining-days-field">
          <mat-label>Number of Days for Extension</mat-label>
          <input matInput type="number" min="1" [max]="getMaxNumberOfDays()" [formControl]="daysOfExtension" (input)="updateExpiryDate($event)">
        </mat-form-field>
      </div>
    </div>
  }
</div>
<div mat-dialog-actions class="buttons-container">
  <button mat-raised-button class="mat-accent" (click)="closeDialog(true)" [disabled]="!isFormValid()"
  id="popupConfirm">Extend</button>
  <button mat-raised-button (click)="closeDialog(false)" id="popupCancel">Cancel</button>
</div>